// import permissionsMap from '@/modules/auth/helper/permissionsMap'

const Module = () =>
  import(/* webpackChunkName: "home-module" */ '@/modules/home/Module.vue')
const Home = () =>
  import(/* webpackChunkName: "home-module" */ '@/modules/home/views/Home.vue')

const routes = [
  {
    path: '/my_farm',
    component: Module,
    children: [
      {
        name: 'home',
        path: '/',
        component: Home,
        meta: {
          // FIXME: So far, the '/permissions' endpoint is called AFTER the first reroute to
          // 'my_farms', so it's not possible to validate using permissions. Once the need
          // for 'seasonsCrops' parameter is removed from '/permissions', the commented
          // code can be applied
          // permission: permissionsMap.farm.view,
          requiresAuth: true,
        },
      },
    ],
    meta: {
      // FIXME: So far, the '/permissions' endpoint is called AFTER the first reroute to
      // 'my_farms', so it's not possible to validate using permissions. Once the need
      // for 'seasonsCrops' parameter is removed from '/permissions', the commented
      // code can be applied
      // permission: permissionsMap.farm.view,
      requiresAuth: true,
    },
  },
]

export default routes
